// LOGIN_USUARIO_2810 (GROK2): login por usuário (estilo Sigma). Switch private/LOGIN_USUARIO_2810_OFF.
// O backend guarda <usuario>@usuario.aurax como e-mail interno; nunca mostramos isso.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL as API_URL } from '../apiBase';

export const LOGIN_DOMAIN_2810 = 'usuario.aurax';
export const LOGIN_USER_RE_2810 = /^[a-z0-9._-]{3,32}$/;
export const isSyntheticLogin2810 = (v) => String(v || '').trim().toLowerCase().endsWith('@' + LOGIN_DOMAIN_2810);
export const usernameFromEmail2810 = (v) => (isSyntheticLogin2810(v) ? String(v).trim().toLowerCase().split('@')[0] : '');
export const displayLogin2810 = (v) => (isSyntheticLogin2810(v) ? usernameFromEmail2810(v) : v);
export const normLoginUser2810 = (v) => String(v || '').trim().toLowerCase();

const KEY = 'aurax_login_usuario_2810';
export function useLoginUsuario2810() {
  const [on, setOn] = useState(() => { try { return localStorage.getItem(KEY) === '1'; } catch { return false; } });
  useEffect(() => {
    let alive = true;
    axios.get(`${API_URL}/api/auth/login-mode`).then((r) => {
      const v = !!r?.data?.usuario;
      try { localStorage.setItem("aurax_login_dragao_3110", r?.data?.login_dragao_3110 === false ? "0" : "1"); } catch { /* LOGIN_DRAGAO_3110 */ }
      if (alive) setOn(v);
      try { localStorage.setItem(KEY, v ? '1' : '0'); } catch { /* ignore */ }
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return on;
}
